export default "/_next/static/images/controls--play-01dc2d8d5edd96c40758724024255430.svg";